import { useAppSelector } from '../store/hooks'
import { formatRelativeTime } from '../utils/formatRelativeTime'

export const useRelativeTime = () => {
    const timezone = useAppSelector(state => state.auth?.timezone || '')
    const tz = (timezone && timezone !== 'Auto')
        ? timezone
        : Intl.DateTimeFormat().resolvedOptions().timeZone

    return (date: { toDate?: () => Date; seconds?: number } | null | undefined) =>
        formatRelativeTime(date, tz)
}
